function initHeroSlider() {

  document.querySelectorAll(".hz-slider").forEach((slider) => {

    if (slider.dataset.initialized) return;
slider.dataset.initialized = "true";
    const slides = slider.querySelectorAll(".hz-slide");
    const dots = slider.querySelectorAll(".hz-hero-dot");
    const prev = slider.querySelector(".hz-prev");
    const next = slider.querySelector(".hz-next");

    if (slides.length <= 1) return;

    let current = 0;
    let timer = null;

    const autoplay =
      slider.dataset.autoplay === "true";

    const speed =
      parseInt(slider.dataset.speed || "5") * 1000;

    function goTo(index) {

      if (index < 0)
        index = slides.length - 1;

      if (index >= slides.length)
        index = 0;

      slides.forEach((slide, i) => {

        slide.classList.toggle(
          "active",
          i === index
        );

      });

      dots.forEach((dot, i) => {

        dot.classList.toggle(
          "active",
          i === index
        );

      });

      current = index;

    }

    function nextSlide() {

      goTo(current + 1);

    }

    function prevSlide() {

      goTo(current - 1);

    }

    function start() {

      if (!autoplay) return;

      stop();

      timer = setInterval(() => {

        nextSlide();

      }, speed);

    }

    function stop() {

      if (timer) {

        clearInterval(timer);

        timer = null;

      }

    }

    next?.addEventListener("click", () => {

      nextSlide();

      start();

    });

    prev?.addEventListener("click", () => {

      prevSlide();

      start();

    });

    dots.forEach((dot, index) => {

      dot.addEventListener("click", () => {

        goTo(index);

        start();

      });

    });

    /* ---------------- Swipe ---------------- */

    let startX = 0;
    let endX = 0;

    slider.addEventListener("touchstart", (e) => {

      startX = e.touches[0].clientX;

    });

    slider.addEventListener("touchend", (e) => {

      endX = e.changedTouches[0].clientX;

      if (startX - endX > 60) {

        nextSlide();

        start();

      }

      if (endX - startX > 60) {

        prevSlide();

        start();

      }

    });

    /* ---------------- Pause on Hover ---------------- */

    slider.addEventListener("mouseenter", stop);

    slider.addEventListener("mouseleave", start);

    goTo(0);

    start();

  });

}

document.addEventListener("DOMContentLoaded", initHeroSlider);
document.addEventListener("shopify:section:load", initHeroSlider);